/**
 * made-to-measure.js  →  assets/made-to-measure.js
 */

(function () {
  'use strict';

  function getMtmVariantId() {
    var block = document.querySelector('[data-mtm-block]');
    if (!block) return null;
    return (block.getAttribute('data-mtm-variant-ids') || '').split(',')[0].trim() || null;
  }

  function getCurrentVariantId() {
    var input = document.querySelector(
      'form[action="/cart/add"] input[name="id"], ' +
      'form[action="/cart/add"] select[name="id"], ' +
      'input[name="id"], select[name="id"]'
    );
    return input ? String(input.value) : null;
  }

  // ─── Hide ONLY the MTM pill — re-run after every variant change ──────────
  function hideMtmFromSizeGrid() {
    document.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      var isMtm =
        (radio.value && radio.value.indexOf('MADE TO MEASURE') !== -1) ||
        (radio.value && radio.value.indexOf('Made to Measure') !== -1);

      if (!isMtm) return;

      radio.style.cssText += ';display:none!important';

      var label = document.querySelector('label[for="' + radio.id + '"]')
               || radio.closest('label');
      if (label) {
        label.style.cssText += ';display:none!important';

        // Only hide parent if it's a single-radio wrapper (a pill), not the whole grid
        var parent = label.parentElement;
        if (parent && parent.querySelectorAll('input[type="radio"]').length <= 1) {
          parent.style.cssText += ';display:none!important';
        }
      }
    });
  }

  // ─── Show/hide the MTM form block ────────────────────────────────────────
  function updateMtmVisibility() {
    var currentId = getCurrentVariantId();
    var mtmId     = getMtmVariantId();
    var isMtm     = !!(currentId && mtmId && currentId === mtmId);

    document.querySelectorAll('[data-mtm-block]').forEach(function (block) {
      block.style.display = isMtm ? 'block' : 'none';
      block.querySelectorAll('[data-mtm-field]').forEach(function (f) {
        f.disabled = !isMtm;
      });
    });

    document.querySelectorAll('.mtm-header-bar').forEach(function (bar) {
      bar.classList.toggle('mtm-header-bar--active', isMtm);
    });

    // Re-hide the MTM button from the size grid every time (Dawn may re-render it)
    hideMtmFromSizeGrid();
  }

  // ─── Programmatically select / deselect MTM ─────────────────────────────
  function selectMtmVariant() {
    var radio = document.querySelector(
      'input[type="radio"][value*="MADE TO MEASURE"], ' +
      'input[type="radio"][value*="Made to Measure"]'
    );
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var input = document.querySelector('input[name="id"], select[name="id"]');
      var mtmId = getMtmVariantId();
      if (input && mtmId) {
        input.value = mtmId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function deselectMtmVariant() {
    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (
        r.value.indexOf('MADE TO MEASURE') === -1 &&
        r.value.indexOf('Made to Measure') === -1
      ) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  // ─── Dark header bar = the MTM selector ─────────────────────────────────
  function initHeaderToggle() {
    document.querySelectorAll('.mtm-header-bar').forEach(function (bar) {
      bar.addEventListener('click', function () {
        if (getCurrentVariantId() === getMtmVariantId()) deselectMtmVariant();
        else selectMtmVariant();
      });
    });
  }

  // ─── Watch for any variant change ───────────────────────────────────────
  function initVariantWatcher() {
    function onAnyChange() {
      // Delay so Dawn finishes re-rendering before we read + re-hide
      setTimeout(updateMtmVisibility, 50);
    }

    document.addEventListener('change',            onAnyChange);
    document.addEventListener('variant:changed',   onAnyChange);
    document.addEventListener('on:variant:change', onAnyChange);

    // URL polling — Dawn updates ?variant= on every selection
    var lastSearch = location.search;
    setInterval(function () {
      if (location.search !== lastSearch) {
        lastSearch = location.search;
        updateMtmVisibility();
      }
    }, 300);

    updateMtmVisibility();
  }

  // ─── Cart validation ─────────────────────────────────────────────────────
  function initValidation() {
    document.querySelectorAll('product-form').forEach(function (el) {
      var form = el.querySelector('form[action="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function (e) {
        var block = document.querySelector('[data-mtm-block]');
        if (!block || block.style.display === 'none') return;

        var fields  = block.querySelectorAll('[data-mtm-field]:not([disabled])');
        var errorEl = block.querySelector('.mtm-error');
        var valid   = true;

        fields.forEach(function (f) {
          if (f.value.trim() === '') { f.classList.add('is-invalid'); valid = false; }
          else f.classList.remove('is-invalid');
        });

        if (!valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (errorEl) {
            errorEl.style.display = 'block';
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        } else {
          if (errorEl) errorEl.style.display = 'none';
        }
      }, { capture: true });

      form.addEventListener('input', function (e) {
        if (e.target && e.target.matches('[data-mtm-field]')) {
          e.target.classList.remove('is-invalid');
        }
      });
    });
  }

  // ─── Init ────────────────────────────────────────────────────────────────
  function init() {
    hideMtmFromSizeGrid();
    setTimeout(hideMtmFromSizeGrid, 300);
    initHeaderToggle();
    initVariantWatcher();
    initValidation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
